// extracted by mini-css-extract-plugin
export default {"content":"options_content__Vwi4-","title":"options_title__ZWO2R","customerName":"options_customerName__ntdah","sub_title":"options_sub_title__VNDDn"};